import { logError } from "src/shared/logError";
import { getMonsAppName, getMonsSiteName, getUrl } from "src/shared/getMetaData";

const CLIENT_TYPE = 'VIBES_DESKTOP';

export interface GetQuestionForSellerOutput {
    isInCooldown: boolean;
    question?: Question;
}

export interface SubmitQuestionResponseOutput {
    followUpQuestion?: Question;
}
export interface Question {
    id?: string;
    text?: string;
    type?: string;
    locale?: string;
    responseOptions?: ResponseOption[];
}
export interface ResponseOption {
    id?: string;
    text?: string;
}

export default class PulseTnTService {
    private readonly host: string;
    private readonly csrfToken: string;

    constructor(host: string, csrfToken = '') {
        this.host = host;
        this.csrfToken = csrfToken;
    }

    async getQuestion(): Promise<GetQuestionForSellerOutput | null> {
        try {
            const res = await fetch(`${this.host}/pulse/v1/question`, {
                method: 'POST',
                redirect: 'error',
                headers: {
                    'Accept': "application/json",
                    'Content-Type': 'application/json',
                    'anti-csrftoken-a2z': this.csrfToken,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                    runtimeAttributes: {
                        mons_site: getMonsSiteName(document),
                        mons_app: getMonsAppName(document)
                    },
                    surveyClient: CLIENT_TYPE
                })
            });

            // Fail gracefully, but log the error
            if (!res.ok) {
                logError("Error getting question for seller", "Error getting question for seller");
                return null;
            }

            return await res.json() as GetQuestionForSellerOutput;
        } catch (e) {
            logError(e, "Error while fetching Pulse GetQuestion API");
            return null;
        }

    }

    async submitResponse(questionId: string, rating: number, selectedOptionId: string, feedback: string, context: Document): Promise<SubmitQuestionResponseOutput | null> {
        try {
            const res = await fetch(`${this.host}/pulse/v1/response`, {
                method: 'POST',
                redirect: 'error',
                headers: {
                    'Accept': "application/json",
                    'Content-Type': 'application/json',
                    'anti-csrftoken-a2z': this.csrfToken,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                    questionId: questionId,
                    surveyClient: CLIENT_TYPE,
                    textResponse: feedback,
                    rating: rating,
                    selectedResponseId: [selectedOptionId],
                    responseMetadata: {
                        mons_site: getMonsSiteName(context),
                        mons_app: getMonsAppName(context),
                        url: getUrl(),
                    }
                })
            });

            if (!res.ok) {
                logError("Error submitting question response", "Error submitting question response");
                return null;
            }

            return await res.json() as SubmitQuestionResponseOutput;
        } catch (e) {
            logError(e, "Error while calling Pulse SubmitResponse API");
            return null;
        }
    }

    async registerEvent(questionId: string, eventType: 'RENDERED' | 'DISMISSED' | 'DEFERRED', context: Document) {
        try {
            const res = await fetch(`${this.host}/pulse/v1/event`, {
                method: 'POST',
                redirect: 'error',
                headers: {
                    'Accept': "application/json",
                    'Content-Type': 'application/json',
                    'anti-csrftoken-a2z': this.csrfToken,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                    questionId: questionId,
                    surveyClient: CLIENT_TYPE,
                    eventType: eventType,
                    eventMetadata: {
                        mons_site: getMonsSiteName(context),
                        mons_app: getMonsAppName(context),
                        url: getUrl(),
                    }
                })
            });

            if (!res.ok) {
                logError("Error submitting event", "Error submitting question response");
            }
        } catch (e) {
            logError(e, "Error while calling Pulse RegisterEvent API");
        }
    }
}